import React from 'react';
import { motion } from 'framer-motion';
import { Quote } from 'lucide-react';
import { SectionHeading } from './ui/SectionHeading';
import { useLanguage } from '../i18n/LanguageContext';
export function Story() {
  const {
    t
  } = useLanguage();
  return <section id="historia" className="pt-10 md:pt-14 pb-20 md:pb-28 bg-riam-dark" data-id="element-276">
      <div className="container mx-auto px-4 md:px-6" data-id="element-277">
        <SectionHeading title={`${t.story.title1}<span class='font-allura font-normal text-5xl md:text-6xl lg:text-7xl block mt-2'>${t.story.titleHighlight}</span>`} data-id="element-278" />

        <div className="flex flex-col lg:flex-row items-start gap-12 lg:gap-20 max-w-6xl mx-auto mt-16" data-id="element-279">
          {/* Image Column */}
          <motion.div initial={{
          opacity: 0,
          x: -30
        }} whileInView={{
          opacity: 1,
          x: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.8
        }} className="w-full lg:w-1/2 lg:sticky lg:top-28 self-start" data-id="element-280">
            <div className="portrait-frame relative" data-id="element-281">
              <span className="portrait-corner tl" data-id="element-282" />
              <span className="portrait-corner tr" data-id="element-283" />
              <span className="portrait-corner bl" data-id="element-284" />
              <span className="portrait-corner br" data-id="element-285" />

              <img src="https://cdn.magicpatterns.com/uploads/8WUfmRPHsAgFgHSSWtjLwM/ROSI_OWNER.jpg" alt="Rosy Añazco, Fundadora" className="w-full h-auto object-cover rounded-sm grayscale-[8%] contrast-110 saturate-105" data-id="element-286" />

              <div className="absolute -bottom-5 left-1/2 -translate-x-1/2 bg-riam-black px-5 py-2 border border-riam-gold/40 rounded-sm" data-id="element-287">
                <p className="gold-shine-soft font-sans font-semibold text-[0.65rem] tracking-[0.4em] uppercase whitespace-nowrap" data-id="element-288">
                  {t.story.founder} <span className="opacity-60" data-id="element-289">·</span>{' '}
                  {t.story.founderTitle}
                </p>
              </div>
            </div>
          </motion.div>

          {/* Text Column */}
          <motion.div initial={{
          opacity: 0,
          x: 30
        }} whileInView={{
          opacity: 1,
          x: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.8
        }} className="w-full lg:w-1/2 space-y-6 font-sans font-normal text-lg text-riam-gold-light/90 leading-relaxed" data-id="element-290">
            <p data-id="element-291">
              {t.story.p1_1}
              <span className="font-allura font-normal text-3xl md:text-4xl align-middle mr-1 text-riam-gold" data-id="element-292">
                {t.story.p1_highlight}
              </span>{' '}
              {t.story.p1_2}
            </p>
            <p data-id="element-293">
              {t.story.p2_1}
              <span className="font-allura font-normal text-3xl md:text-4xl align-middle mr-1 text-riam-gold" data-id="element-294">
                {t.story.p2_highlight}
              </span>{' '}
              {t.story.p2_2}
            </p>
            <p className="gold-shine font-script font-semibold italic text-2xl md:text-3xl py-2" data-id="element-295">
              {t.story.p3_1}
              <span className="font-allura font-normal text-4xl md:text-5xl align-middle mx-1" data-id="element-296">
                {t.story.p3_highlight}
              </span>
              {t.story.p3_2}
            </p>
            <p data-id="element-297">{t.story.p4}</p>
            <p data-id="element-298">{t.story.p5}</p>

            <blockquote className="quote-luminous relative pl-10 pr-8 py-10 mt-8 bg-riam-black/60 backdrop-blur-sm rounded-sm overflow-hidden" data-id="element-299">
              {/* Animated vertical gold accent */}
              <div className="gold-divider-vertical absolute left-0 top-4 bottom-4" data-id="element-300" />

              {/* Large luminous opening quote */}
              <Quote className="absolute -top-2 left-6 icon-glow-strong opacity-30" size={72} stroke="url(#riamGold)" data-id="element-301" />

              {/* Mirrored closing quote */}
              <Quote className="absolute bottom-2 right-4 icon-glow opacity-20" size={56} stroke="url(#riamGold)" style={{
              transform: 'rotate(180deg)'
            }} data-id="element-302" />

              <p className="gold-shine-soft relative z-10 font-script font-semibold italic text-2xl md:text-3xl leading-relaxed mb-5" data-id="element-303">
                {t.story.quote_1}
                <span className="font-allura font-normal text-4xl md:text-5xl align-middle mx-1" data-id="element-304">
                  {t.story.quote_highlight}
                </span>
                {t.story.quote_2}
              </p>

              <footer className="relative z-10 text-riam-gold-dark" data-id="element-305">
                <span className="font-sans font-medium text-xs tracking-[0.3em] uppercase" data-id="element-306">
                  —{' '}
                </span>
                <span className="font-allura font-normal text-2xl md:text-3xl align-middle text-riam-gold" data-id="element-307">
                  {t.story.founder}
                </span>
                <span className="font-sans font-medium text-xs tracking-[0.3em] uppercase" data-id="element-308">
                  , {t.story.founderTitle}
                </span>
              </footer>
            </blockquote>

            <p className="gold-shine-soft pt-4 font-semibold" data-id="element-309">
              {t.story.p6_1}
              <span className="font-allura font-normal text-3xl md:text-4xl align-middle mr-1" data-id="element-310">
                {t.story.p6_highlight}
              </span>{' '}
              {t.story.p6_2}
            </p>
            <p data-id="element-311">{t.story.p7}</p>
          </motion.div>
        </div>
      </div>
    </section>;
}